<div class="execute-query-container">
    <h2>Execute SQL Query</h2>

    <!-- SQL Query Section -->
    <div class="sql-query-section">
        <div class="form-group">
            <label for="sqlQuery">SQL Query</label>
            <textarea 
                id="sqlQuery" 
                class="form-control" 
                rows="4" 
                [(ngModel)]="sqlQuery" 
                placeholder="Enter your SQL query here..."
            ></textarea>
        </div>
        <button 
            class="btn btn-primary execute-btn" 
            (click)="executeSqlQuery()"
            [disabled]="!sqlQuery"
        >
            Execute Query
        </button>
    </div>

    <!-- Query Results Table -->
    <div class="query-results-table" *ngIf="queryResults && queryResults.length > 0">
        <h3>Query Results</h3>
        <p-table 
            #dtQuery
            [value]="queryResults" 
            [loading]="loading"
            [paginator]="true" 
            [rows]="10"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10,25,50]"
            [globalFilterFields]="globalFilterFields"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [scrollable]="true"
            styleClass="p-datatable-gridlines"
        >
            <ng-template pTemplate="caption">
                <div class="flex justify-content-between align-items-center">
                    <h5 class="m-0">Query Results</h5>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="onGlobalFilter($event)" placeholder="Search..." />
                    </span>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of queryColumns" [pSortableColumn]="col.field" [style]="{'min-width': '150px'}">
                        {{col.header}}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row>
                <tr>
                    <td *ngFor="let col of queryColumns">{{row[col.field]}}</td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="queryColumns.length" class="text-center">
                        No results found.
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div> 